module.exports = __webpack_public_path__ + "static/media/rekola.f964b2ba.jpg";